import Vue from 'vue';
import Vuex from 'vuex';
// Modules
import common from '@/store/modules/common';
import neighregistration from '@/store/modules/neighregistration';
import unit from '@/store/modules/unit';
import person from '@/store/modules/person';
import notifications from '@/store/modules/notifications';
// Vecino
import manageVecino from '@/store/Vecino/manage';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    neighregistration,
    unit,
    person,
    manageVecino,
    notifications
  }
});